import { styled } from '@mui/material/styles';

export const HideSmallSpan = styled('span', {
  shouldForwardProp: (prop) => prop !== 'hide',
})(({ theme, hide }) => ({
  fontWeight: 'bold',
  ...(hide && {
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
  }),
}));
